export default __webpack_public_path__ + "static/media/mpk_logo.1c235a57.png";